// Type: regular or warranty at the moment.
export const messages = type => {
  return {
    MISSION_TEXT: `age_gate.components.${type}.mission_text`,

    COOKIE_POLICY: `age_gate.components.${type}.cookie-policy`,

    AGE_REQUIREMENT_LINK_TEXT: `age_gate.components.${type}.age_requirement.link_text`,
    AGE_REQUIREMENT_TEXT: `age_gate.components.${type}.age_requirement.text`,
    AGE_REQUIREMENT_URL: `age_gate.components.${type}.age_requirement.url`,

    SELECT_STATE_COPY: `age_gate.components.${type}.select_state_copy`,
    SELECT_STATE_LABEL: `age_gate.components.${type}.select_state_label`,

    BLOCKED_STATE_WARNING: `age_gate.components.${type}.blocked_state_warning`,

    ROUTE_TO_LOCATOR_TEXT: `age_gate.components.${type}.route_to_locator_text`,
    AGREE_TEXT: `age_gate.components.${type}.agree_text`,

    DISAGREE_LINK_TEXT: `age_gate.components.${type}.disagree.link_text`,
    DISAGREE_TEXT: `age_gate.components.${type}.disagree.text`,
    DISAGREE_URL: `age_gate.components.${type}.disagree.url`,

    RESELLER_WARNING_URL: `age_gate.components.${type}.reseller_warning.url`,
    RESELLER_WARNING_TEXT: `age_gate.components.${type}.reseller_warning.text`,
    RESELLER_WARNING_LINK_TEXT: `age_gate.components.${type}.reseller_warning.link_text`,

    WARRANTY_SUPPORT_URL: `age_gate.components.${type}.warranty_support.url`,
    WARRANTY_SUPPORT_TEXT: `age_gate.components.${type}.warranty_support.text`,
    WARRANTY_SUPPORT_LINK_TEXT: `age_gate.components.${type}.warranty_support.link_text`,

    AV_REQUIRED: `age_gate.components.${type}.av_required`,

    LANGUAGE_SELECTOR: `age_gate.components.${type}.language_selector`,
  };
};
